"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDpUserProfile = void 0;
var react_1 = require("react");
var Auth_1 = require("../../../modules/Auth");
var context_1 = require("../../context");
var use_roles_effect_1 = require("../use-roles-effect");
var useHttpErrorHandler_hook_1 = require("../useHttpErroHandler/useHttpErrorHandler.hook");
var useDpUserProfile = function (_a) {
    var isRoleSwitchVisible = _a.isRoleSwitchVisible, onLogoutCallback = _a.onLogoutCallback;
    var authService = (0, react_1.useContext)(context_1.ServiceContext).authService;
    var _b = (0, react_1.useContext)(Auth_1.AuthContext), impersonation = _b.impersonation, impersonatorName = _b.impersonatorName;
    var handleHTTPError = (0, useHttpErrorHandler_hook_1.useHttpErroHandler)().handleHTTPError;
    var _c = (0, use_roles_effect_1.useRolesEffect)(), availableRoles = _c.availableRoles, activeRole = _c.activeRole, handleRoleChange = _c.handleRoleChange;
    var onLogout = function () { return __awaiter(void 0, void 0, void 0, function () {
        var logoutData, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, authService.logout()];
                case 1:
                    logoutData = _a.sent();
                    window.location.assign(logoutData.redirectUrl);
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    handleHTTPError(err_1)();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onEndImpersonation = function () {
        authService.endImpersonation().then(function (res) {
            var redirectTo = res.body['redirect-user'];
            window.open(redirectTo, '_self');
        });
    };
    // --------------------------------- Render
    return {
        onLogout: onLogoutCallback || onLogout,
        isRoleSwitchVisible: isRoleSwitchVisible || impersonation,
        impersonating: impersonation,
        impersonatorName: impersonation && impersonatorName,
        onEndImpersonation: onEndImpersonation,
        activeRole: activeRole,
        roles: availableRoles,
        onRoleChange: handleRoleChange,
    };
};
exports.useDpUserProfile = useDpUserProfile;
